import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as TrophySvg } from "../../../../assets/chat/trophy.svg";

const _prefix = "chat-tendering__won";

const Won = () => {
  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <TrophySvg width={24} />
        <div className={`${_prefix}__desc`}>
          <span style={{ fontWeight: 500, color: "#013565" }}>
            Congratulation
          </span>
          <span>
            We really appreciate to start working with you. We will send a
            contract to you as soon as a possible. Thank you. 🏆
          </span>
        </div>
      </div>
    </MessageContainer>
  );
};

Won.propTypes = {};

export default Won;
